import React, { useEffect, useState } from "react";
import { Empty } from 'antd';
import AccountTransactionListComponent from './AccountTransactionListComponent'
import RequestHandler from "../../../../util/RequestHandler";
import { odata } from "../../../Filters/Helper";
import moment from "moment";

const AccountPage = (props) => {
  const [accountsList, setAccountList] = useState([])
  const [dataState, setDataState] = useState([{ skip: 0, take: 5 }]);
  const [take, setTake] = useState(5);
  const [skip, setSkip] = useState(0);
  const [activeKey, setActiveKey] = useState('');
  const [query, setQuery] = useState('');
  useEffect(() => {
    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {
        RequestHandler.get(`/AccountTransaction?$filter=${response.isHasDateFilter ? `${odata.dateRange("transactionDateValue", moment(new Date()).add(-1, 'months'), new Date())} and ` : ''}Contains(debtOrCredit,'A') &$count=true&$skip=${skip}&$top=${take}`).then(response => {
          setAccountList(response.value);
        });
      }
      else {
        RequestHandler.get(`/AccountTransaction?$filter=${odata.dateRange("transactionDateValue", moment(new Date()).add(-1, 'months'), new Date())} and Contains(debtOrCredit,'A') &$count=true&$skip=${skip}&$top=${take}`).then(response => {
          setAccountList(response.value);
        });
      }
    });

  }, [query, setDataState, skip, setSkip, setActiveKey]);

  const ContactSideBar = (value) => {
    return <AccountTransactionListComponent data={accountsList} isDigitHomePage={props.isDigitHomePage} />
  };
  return (
    <div>
      {
        accountsList.length === 0 ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Veri Yok" /> :
          ContactSideBar()
      }
    </div>
  )
}

export default AccountPage
